import { makeAutoObservable, observable, action } from 'mobx';
import { FeaturesListType } from 'useCase/featureFlags/types';

interface RemotePropertiesInterface {
    remoteProperties: FeaturesListType | null;
}

class RemotePropertiesStore implements RemotePropertiesInterface {
    @observable public remoteProperties: FeaturesListType | null = null;

    public constructor() {
        makeAutoObservable(this);
    }

    @action
    public setRemoteProperties(properties: FeaturesListType | null) {
        this.remoteProperties = properties;
    }
}

export const remotePropertiesStore = new RemotePropertiesStore();
